import classNames from 'classnames'
import moment from 'moment'
import { NavLink, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import classes from './AccountNavigation.module.scss'
import { useSelector } from 'react-redux'
import { useContext } from 'react'
import { AccountContext } from '../AccountContext'
import { isAdminInFamily, isUserCoachInCommunity } from '../../../utility/userHelper'
import { FAMILY_ADMIN_MIN_AGE } from '../../../misc/Constants'

const AccountNavigation = () => {
  const { t } = useTranslation()
  const { user } = useContext(AccountContext)
  const [searchParams] = useSearchParams()
  const currentUser = useSelector(state => state.user.current_user)

  const isCurrentUser = user.id === currentUser.id
  const isCoach = user.type === 'Coach'
  const isFamilyAdmin = currentUser.type === 'Student' && currentUser.family_admin
  const canChangePassword = isCurrentUser || (isFamilyAdmin && !user.family_admin)

  const isAllowedToSeeTheirOwnSettings = currentUser.type === 'Coach' || currentUser.family_admin
  const isAllowedToSeeOtherUserSettings =
    isAdminInFamily(currentUser, user) ||
    isUserCoachInCommunity(currentUser, user)
  const isAllowedToAccessSettings = isCurrentUser ? isAllowedToSeeTheirOwnSettings : isAllowedToSeeOtherUserSettings

  const isUnderThirteen = user.birthdate && moment().diff(user.birthdate, 'years') < FAMILY_ADMIN_MIN_AGE
  const canManageChildPrivacy = isFamilyAdmin && !isCurrentUser && !user.family_admin && isUnderThirteen

  const currentTab = searchParams.get('editTab')

  return (
    <nav>
      <ul className={classNames(classes.accountNavigation, 'py-2')}>
        <li>
          <NavLink
            to={{ search: '?editTab=personal' }}
            className={classNames({ [classes.active]: currentTab === 'personal' || currentTab === null })}
          >
            {t('account.navigation.personal')}
          </NavLink>
        </li>
        <li>
          <NavLink
            to={{ search: '?editTab=profile' }}
            className={classNames({ [classes.active]: currentTab === 'profile' })}
          >
            {t('account.navigation.profile')}
          </NavLink>
        </li>
        {isCoach && (
          <li>
            <NavLink
              to={{ search: '?editTab=booking' }}
              className={classNames({ [classes.active]: currentTab === 'booking' })}
            >
              {t('account.navigation.booking')}
            </NavLink>
          </li>
        )}
        {isCurrentUser && isCoach && (
          <li>
            <NavLink
              to={{ search: '?editTab=notifications' }}
              className={classNames({ [classes.active]: currentTab === 'notifications' })}
            >
              {t('account.navigation.notifications')}
            </NavLink>
          </li>
        )}
        {isCurrentUser && (
          <li>
            <NavLink
              to={{ search: '?editTab=language' }}
              className={classNames({ [classes.active]: currentTab === 'language' })}
            >
              {t('common.language')}
            </NavLink>
          </li>
        )}
        {canManageChildPrivacy && (
          <li>
            <NavLink
              to={{ search: '?editTab=privacy-settings' }}
              className={classNames({ [classes.active]: currentTab === 'privacy-settings' })}
            >
              Privacy Settings
            </NavLink>
          </li>
        )}
        {canChangePassword && (
          <li>
            <NavLink
              to={{ search: '?editTab=change-password' }}
              className={classNames({ [classes.active]: currentTab === 'change-password' })}
            >
              {t('account.navigation.changePassword')}
            </NavLink>
          </li>
        )}
        {isAllowedToAccessSettings && (
          <li>
            <NavLink
              to={{ search: '?editTab=account-settings' }}
              className={classNames({ [classes.active]: currentTab === 'account-settings' })}
            >
              {t('account.common.accountSettings')}
            </NavLink>
          </li>
        )}
      </ul>
    </nav>
  )
}

export default AccountNavigation
